import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Modal, Grid, Input, Icon, Table } from 'semantic-ui-react';

import cm from 'helpers/commons';
import { Commons } from 'components';

const propTypes = {};

const defaultProps = {};

class StoreSearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.modal.open) {
      this.setState({ keyword: null });
    }
  }

  handleEvent = () => {
    const { keyword } = this.state;
    const { storeSel } = this.props;

    storeSel(1, keyword);
  };
  handleChange = (e) => {
    this.setState({ keyword: e.target.value });
  };
  handleEntEvent = (e) => {
    if (e.key === 'Enter') {
      this.handleEvent();
    }
  };

  storeClick = (data) => {
    const { choiceEvent } = this.props;
    choiceEvent(data.name, data.id);
  };

  pageClick = async (page) => {
    const { keyword } = this.state;
    const { storeSel } = this.props;

    storeSel(page, keyword);
  };

  render() {
    const { size, open, dimmer, close } = this.props.modal;
    const { keyword } = this.state;
    const { storeList } = this.props;

    let dom = document.getElementsByClassName('modal')[0];
    const style = {
      content: {
        width: dom ? dom.offsetWidth : null,
        overflow: 'auto'
      }
    };

    const tabledata = {
      header: {
        main: [
          { data: '가맹점', textAlign: 'left' },
          { data: '연락처', textAlign: 'left' },
          { data: '업종', textAlign: 'left' },
          { data: '지역', textAlign: 'left' },
          { data: '상태', textAlign: 'left' }
        ]
      },
      body: {
        main: null
      }
    };

    let page = 1,
      pagerow = 10,
      totalcount = 0;
    if (storeList && storeList.data.store) {
      const { paging, store } = storeList.data;

      page = paging.page;
      pagerow = paging.pagerow;
      totalcount = paging.totalcount;

      tabledata.body.main = store.map((data) => {
        const obj = {
          clickFunc: this.storeClick,
          clickData: { name: data.name, id: data.id },
          row: [
            {
              data: data.name,
              //, clickFunc : (e) => this.storeClick(data.name, data.id)
              textAlign: 'left'
            },
            {
              data: cm.phoneFormat(data.phone),
              textAlign: 'left'
            },
            {
              data: data.category,
              textAlign: 'left'
            },
            {
              data: data.region,
              textAlign: 'left'
            },
            {
              data: data.isactive ? '활성' : '비활성',
              textAlign: 'left'
            }
          ]
        };

        return obj;
      });
    }

    return (
      <Modal className="modal-large" size={size} dimmer={dimmer} open={open} onClose={(e) => close('close', false)}>
        <Modal.Header>가맹점 선택</Modal.Header>
        <Modal.Content>
          {storeList ? (
            <div>
              <div className="form-input">
                <Input
                  value={keyword ? keyword : ''}
                  action={{
                    icon: 'search',
                    onClick: this.handleEvent
                  }}
                  placeholder="가맹점명"
                  onChange={this.handleChange}
                  onKeyPress={this.handleEntEvent}
                />
              </div>

              <div className="table-box">
                <Commons.TableForm tabledata={tabledata} selectable="true" />
              </div>

              <div className="table-paging">
                <Commons.Pagination
                  page={page}
                  pageRow={pagerow}
                  pageBlock={10}
                  totalCount={totalcount}
                  pageClick={this.pageClick}
                />
              </div>
            </div>
          ) : (
            <div style={{ height: '632px' }}>
              <Commons.LoadingBar />
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button positive content="확인" onClick={(e) => close('close', false)} />
        </Modal.Actions>
      </Modal>
    );
  }
}

StoreSearchModal.propTypes = propTypes;
StoreSearchModal.defaultProps = defaultProps;

StoreSearchModal = connect(
  (state) => ({
    storeList: state.commons.companyStore
  }),
  (dispatch) => ({})
)(StoreSearchModal);

export default StoreSearchModal;
